import { render, staticRenderFns } from "./MaterialityTop.vue?vue&type=template&id=4aa4ad34&scoped=true"
import script from "./MaterialityTop.vue?vue&type=script&lang=js"
export * from "./MaterialityTop.vue?vue&type=script&lang=js"
import style0 from "./MaterialityTop.vue?vue&type=style&index=0&id=4aa4ad34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa4ad34",
  null
  
)

export default component.exports